import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UpdateWarningComponent } from './update-warning.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [UpdateWarningComponent]
})
export class UpdateWarningModule {}
